import React, { Component } from 'react';
import { authenticate, updateModifiedDate } from '../../api/legacy';
import { authenticateLegacy } from '../../api/authentication';
import {
  loadAnnotations,
  saveAnnotations,
  retrieveExportData
} from '../../api/annotation';
import queryString from 'query-string';

export class AnnotationImport extends Component {
  constructor(props) {
    super(props);
    this.state = { presets: {}, userId: '' };
    this.internalSaveAnnotations = this.internalSaveAnnotations.bind(this);
  }

  async componentDidMount() {
    const parsed = queryString.parse(this.props.location.search);
    const client = this.props.match.params.client;
    const applicationSessionId = parsed.appSessionId;
    const sessionId = parsed.sessionId;

    try {
      const exportData = await retrieveExportData();

      for (let i = 0; i < exportData.length; i++) {
        const { docid, page, text, creationtime, user } = exportData[i];
        try {
          let tmpAnnotations = null;
          let annotations = null;
          await authenticate(client, docid, applicationSessionId, sessionId);

          const response = await authenticateLegacy(
            client,
            docid,
            applicationSessionId,
            sessionId
          );
          const token = response.token;

          tmpAnnotations = await loadAnnotations(token, client, docid);

          if (
            tmpAnnotations !== null &&
            tmpAnnotations.instantJson &&
            tmpAnnotations.instantJson.annotationJSON
          ) {
            annotations = tmpAnnotations.instantJson.annotationJSON;
            if (annotations.pdfId) {
              annotations.pdfId = null;
            }
          } else {
            annotations = {
              annotations: [],
              format: 'https://pspdfkit.com/instant-json/v1',
              pdfId: null
            };
          }

          let z = 0;
          for (let index = 0; index < annotations.annotations.length; index++) {
            if (annotations.annotations[index].pageIndex === page) {
              z++;
            }
          }
          let y = z * 40;
          annotations.annotations.push({
            bbox: [5, y, 24, 24],
            color: '#FFD83F',
            createdAt: creationtime,
            icon: 'comment',
            id: new Date().getTime() + i + '',
            name: new Date().getTime() + i + '',
            opacity: 1,
            pageIndex: page,
            text: text,
            type: 'pspdfkit/note',
            updatedAt: new Date().getTime(),
            v: 1,
            creatorName: user
          });

          this.internalSaveAnnotations(annotations, token, docid);
        } catch (error) {
          console.log('caught error');
          if (docid) {
            console.log('error docid', docid);
          }
          console.log('error index', i);
        }
      }
    } catch (error) {
      console.log('caught error');
      console.log(error);
      this.setState((state, props) => {
        return {
          error: true,
          errorMessage: error
        };
      });
    }
  }

  internalSaveAnnotations(instantJson, token, documentId) {
    const client = this.props.match.params.client;
    saveAnnotations(token, client, documentId, instantJson);
    const parsed = queryString.parse(this.props.location.search);
    const applicationSessionId = parsed.appSessionId;
    const sessionId = parsed.sessionId;
    updateModifiedDate(client, documentId, applicationSessionId, sessionId);
  }

  render() {
    let errorDisplay = null;
    if (this.state.error) {
      errorDisplay = <span>{this.state.errorMessage}</span>;
    }
    return <div>{errorDisplay}</div>;
  }
}

export default AnnotationImport;
